'use strict';

var ret = {};

ret.methods = ['ACH', 'Check', 'Credit Card', 'Other'];

ret.cards = ['Visa', 'American Express', 'MasterCard', 'Discover'];

module.exports = ret;